import {createFileRoute} from '@tanstack/react-router'

import {Authorisation} from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {ROLES} from "@/lib/auth/roles";
import Adviser from "@/modules/advisers/adviser";

export const Route = createFileRoute('/_auth/advisers/$id')({
  component: RouteComponent,
  loader: async ({params}) => {
    const {id} = params
    return {id}
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [
        {label: 'Advisers', path: '/v2/advisers'},
        {label: 'Edit', path: ''}
      ],
      children: <div className={'h-10'}></div>,
      canSwitchFirm: false
    }
  },
})

function RouteComponent() {
  return (
    <Authorisation
      roles={[ROLES.ROLE_EDIT_ADVISER]}
      permissions={[]}
      forbiddenFallback={<Unauthorized/>}>
      <div className={'flex flex-col items-left justify-center max-sm:p-5'}>
        <Adviser/>
      </div>
    </Authorisation>
  )
}
